import {
  INTAKE_QUESTIONNAIRE_BASE_PATH,
  INTAKE_TAB_IDS,
} from '../../../questionnaires/intake/constants';
import {
  ONBOARDING_QUESTIONNAIRE_BASE_PATH,
  ONBOARDING_TAB_IDS,
} from '../../../questionnaires/onboarding/constants';
import { ACTIVITY_TYPE } from './constants';

import type { IIntakeQuestionnaireBasic } from '../../../../store/questionnaires/intake';
import type { IOnboardingQuestionnaireBasic } from '../../../../store/questionnaires/onboarding';
import type { IClient } from '../../../../utils/types';
import type { Activity } from './types';

export function getActivityPath({ id, type }: Activity) {
  if (type === ACTIVITY_TYPE.ONBOARDING_QUESTIONNAIRE) {
    return `${ONBOARDING_QUESTIONNAIRE_BASE_PATH}/${id}/${ONBOARDING_TAB_IDS.INTRODUCTION}`;
  }

  return `${INTAKE_QUESTIONNAIRE_BASE_PATH}/${id}/${INTAKE_TAB_IDS.INTRODUCTION}`;
}

export function toActivities(
  onboardingQuestionnaires: IOnboardingQuestionnaireBasic[],
  intakeQuestionnaires: IIntakeQuestionnaireBasic[],
): Activity[] {
  const onboardingActivities = onboardingQuestionnaires.map((questionnaire) => ({
    id: questionnaire.id,
    type: ACTIVITY_TYPE.ONBOARDING_QUESTIONNAIRE,
    status: questionnaire.status,
    clientName: getClientName(questionnaire.client),
    startedAt: questionnaire.date_row_created,
  }));

  const intakeActivities = intakeQuestionnaires.map((questionnaire) => ({
    id: questionnaire.id,
    type: ACTIVITY_TYPE.INTAKE_QUESTIONNAIRE,
    status: questionnaire.status,
    clientName: getClientName(questionnaire.client),
    startedAt: questionnaire.date_row_created,
  }));

  return [...onboardingActivities, ...intakeActivities];
}

// The card drops the client line when the name is blank, so tolerate a questionnaire that comes
// back without its nested client rather than rendering "undefined undefined".
function getClientName(client: IClient | undefined) {
  return client ? `${client.first_name} ${client.last_name}` : '';
}
